import { createSlice } from '@reduxjs/toolkit';

const initialState = {fetchHistory: true};

export const profileHistorySlice = createSlice({
    name: 'history',
    initialState,
    reducers: {
        setRefreshProfileHistory: (state, action) => {
            state.fetchHistory = action.payload;
        }
    }
});

export const { setRefreshProfileHistory } = profileHistorySlice.actions;
export const selectRefreshHistory = (state) =>  state.history.fetchHistory;

export default profileHistorySlice.reducer;